import { FeatureSection } from "./AccountFeature";

export const ConnectionSection = ({ connections, toggleConnection }) => {
  const availableConnections = [
    // SOCIAL MEDIA
    {
      name: "Instagram",
      desc: "Connect Instagram account for insights",
      price: "Free",
      logo: "/logos/instagram.png",
      status: "included",
      category: "social",
    },
    {
      name: "Facebook",
      desc: "Sync Facebook page data",
      price: "£15/mo",
      logo: "/logos/facebook.png",
      status: "coming",
      comingSoonDate: "Oct 2025",
      category: "social",
    },
    {
      name: "Twitter (X)",
      desc: "Integrate Twitter/X account for insights",
      price: "£15/mo",
      logo: "/logos/twitter.png",
      status: "coming",
      comingSoonDate: "Nov 2025",
      category: "social",
    },
    {
      name: "LinkedIn Company Page",
      desc: "Pull engagement data from LinkedIn",
      price: "£15/mo",
      logo: "/logos/linkedin.png",
      status: "coming",
      comingSoonDate: "Dec 2025",
      category: "social",
    },
    {
      name: "Pinterest",
      desc: "Track Pinterest traffic & engagement",
      price: "£15/mo",
      logo: "/logos/pinterest.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "social",
    },
    {
      name: "TikTok",
      desc: "Connect TikTok Ads & engagement data",
      price: "£15/mo",
      logo: "/logos/tiktok.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "social",
    },

    // ECOMMERCE
    {
      name: "WooCommerce",
      desc: "Sync store orders & products",
      price: "£15/mo",
      logo: "/logos/woo-logo.png",
      category: "ecommerce",
    },
    {
      name: "Shopify",
      desc: "Integrate Shopify store data",
      price: "£15/mo",
      logo: "/logos/shopify.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "ecommerce",
    },
    {
      name: "Magento",
      desc: "Pull Magento order & customer data",
      price: "£15/mo",
      logo: "/logos/magento.png",
      status: "coming",
      comingSoonDate: "Mar 2026",
      category: "ecommerce",
    },

    // WEBSITE / CMS
    {
      name: "WordPress",
      desc: "Integrate WordPress content data",
      price: "£15/mo",
      logo: "/logos/wp-logo.png",
      category: "cms",
    },
    {
      name: "Drupal",
      desc: "Pull content & performance from Drupal",
      price: "£15/mo",
      logo: "/logos/drupal.png",
      status: "coming",
      comingSoonDate: "Mar 2026",
      category: "cms",
    },
    {
      name: "Contentful",
      desc: "Connect Contentful CMS content data",
      price: "£15/mo",
      logo: "/logos/contentful.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "cms",
    },
    {
      name: "RebelMonkey",
      desc: "Connect RebelMonkey CMS content data",
      price: "£15/mo",
      logo: "/logos/contentful.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "cms",
    },

    // HOSTING
    {
      name: "AWS",
      desc: "Pull website & server metrics from AWS",
      price: "£15/mo",
      logo: "/logos/aws.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "hosting",
    },
    {
      name: "Azure",
      desc: "Connect Azure hosting & analytics",
      price: "£15/mo",
      logo: "/logos/azure.png",
      status: "coming",
      comingSoonDate: "May 2026",
      category: "hosting",
    },
    {
      name: "Google Cloud",
      desc: "Sync GCP server & traffic data",
      price: "£15/mo",
      logo: "/logos/gcp.png",
      status: "coming",
      comingSoonDate: "May 2026",
      category: "hosting",
    },

    // FINANCE / OPERATIONS
    {
      name: "Stripe",
      desc: "Connect Stripe for revenue & subscriptions",
      price: "£15/mo",
      logo: "/logos/stripe.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "finance",
    },
    {
      name: "PayPal",
      desc: "Sync PayPal transactions & revenue",
      price: "£15/mo",
      logo: "/logos/paypal.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "finance",
    },
    {
      name: "Xero",
      desc: "Pull accounting & financial data",
      price: "£15/mo",
      logo: "/logos/xero.png",
      status: "coming",
      comingSoonDate: "Jun 2026",
      category: "finance",
    },
    {
      name: "QuickBooks",
      desc: "Sync QuickBooks accounting data",
      price: "£15/mo",
      logo: "/logos/quickbooks.png",
      status: "coming",
      comingSoonDate: "Jun 2026",
      category: "finance",
    },

    // MARKETING / ADS
    {
      name: "Google Ads",
      desc: "Pull campaign performance from Google Ads",
      price: "£15/mo",
      logo: "/logos/google-ads.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "marketing",
    },
    {
      name: "Facebook Ads",
      desc: "Sync Facebook Ads performance data",
      price: "£15/mo",
      logo: "/logos/facebook-ads.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "marketing",
    },
    {
      name: "LinkedIn Ads",
      desc: "Pull LinkedIn Ads data",
      price: "£15/mo",
      logo: "/logos/linkedin-ads.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "marketing",
    },
    {
      name: "TikTok Ads",
      desc: "Connect TikTok Ads for performance insights",
      price: "£15/mo",
      logo: "/logos/tiktok.png",
      status: "coming",
      comingSoonDate: "Feb 2026",
      category: "marketing",
    },

    // EMAIL / COMMUNICATION
    {
      name: "Mailchimp",
      desc: "Sync email campaigns & audience insights",
      price: "£15/mo",
      logo: "/logos/mailchimp.png",
      category: "email",
    },
    {
      name: "HubSpot",
      desc: "Pull marketing & CRM data from HubSpot",
      price: "£15/mo",
      logo: "/logos/hubspot.png",
      status: "coming",
      comingSoonDate: "Mar 2026",
      category: "marketing",
    },

    // PRODUCTS / INVENTORY
    {
      name: "Zoho Inventory",
      desc: "Sync inventory and product metrics",
      price: "£15/mo",
      logo: "/logos/zoho.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "products",
    },
    {
      name: "Shopify Products",
      desc: "Pull product & stock data from Shopify",
      price: "£15/mo",
      logo: "/logos/shopify.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "products",
    },

    // OPERATIONS / LOGISTICS
    {
      name: "ShipStation",
      desc: "Sync shipping and fulfillment data",
      price: "£15/mo",
      logo: "/logos/shipstation.png",
      status: "coming",
      comingSoonDate: "Apr 2026",
      category: "operations",
    },
    {
      name: "Slack",
      desc: "Pull Slack workspace activity & messages",
      price: "£15/mo",
      logo: "/logos/slack.png",
      status: "coming",
      comingSoonDate: "Mar 2026",
      category: "operations",
    },

    // DOMAIN MANAGEMENT
    {
      name: "GoDaddy",
      desc: "Sync domain info, expiration, and DNS records",
      price: "£15/mo",
      logo: "/logos/godaddy.png",
      status: "coming",
      comingSoonDate: "Nov 2025",
      category: "domain",
    },
    {
      name: "Namecheap",
      desc: "Connect Namecheap to track domain registrations & DNS",
      price: "£15/mo",
      logo: "/logos/namecheap.png",
      status: "coming",
      comingSoonDate: "Nov 2025",
      category: "domain",
    },
    {
      name: "Cloudflare",
      desc: "Pull DNS records, SSL status, and security analytics",
      price: "£15/mo",
      logo: "/logos/cloudflare.png",
      status: "coming",
      comingSoonDate: "Dec 2025",
      category: "domain",
    },
    {
      name: "Google Domains",
      desc: "Sync domain registration & DNS information",
      price: "£15/mo",
      logo: "/logos/google-domains.png",
      status: "coming",
      comingSoonDate: "Dec 2025",
      category: "domain",
    },
    {
      name: "SSL Certificates",
      desc: "Track SSL certificate status and expiration across domains",
      price: "£15/mo",
      logo: "/logos/ssl.png",
      status: "coming",
      comingSoonDate: "Jan 2026",
      category: "domain",
    },
  ];

  return (
    <FeatureSection
      title="Available Connections"
      items={availableConnections}
      selectedItems={connections}
      toggleItem={toggleConnection}
    />
  );
};
